import { defaultPollTime } from "src/organization/pages/project/environment/metrics/resources/settings";
import { TimeFrameType } from "src/organization/pages/project/environment/metrics/resources/types";

import { parseTimeDuration } from "../parseDimensions/parseDimensions";

import { PollStatusType } from "./type";

export const getPollInterval = (timeFrame: TimeFrameType) => {
  return parseTimeDuration(defaultPollTime[timeFrame.id || "fallback"], 15);
};

export const getLoadingOption = (status: PollStatusType) => {
  return {
    refresh: status.type === "refresh" && status.isLoading,
    polling: status.isLoading && status.type === "polling",
    isLoading: status.isLoading,
    status
  };
};

export const initLoadingOption = () => ({
  refresh: true,
  polling: false,
  isLoading: true,
  status: {
    type: "refresh",
    isLoading: true
  }
});
